import React from "react";
import { Box, FormLabel, Switch } from "@material-ui/core";
import { store } from "../store";
import { observer } from "mobx-react-lite";

export const ToggleImperial = observer(() => {
  const { isImperial, toggleImperial } = store;
  return (
    <Box mx={3}>
      <FormLabel>mm</FormLabel>
      <Switch
        checked={isImperial}
        onChange={toggleImperial}
        name="checkedB"
        color="primary"
      />
      <FormLabel>in</FormLabel>
    </Box>
  );
});
